import ChildNapTime from './childNapTime';

export default class SleepArragement {
    public childId = "";
    public id: string  = ""; 
    public napsPerDay: number | undefined = undefined;
    //public napTimes: string[] = []; 
    // public howLong: number = 0;
    public sleepDuration: number = 0;
    public specialRequirements:string = "";
    public visualChecksPrefferences: string = ""; 
    public childNapTimes: Array<ChildNapTime> = [];
}